package floris.graphics.models.dto.requests.category

import floris.graphics.models.domain.models.interfaces.DateAble
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CategoryDto(
    val id: String = "",
    val name: String = "",
    val category: CategoryDto? = null,
    @SerialName("sub_categories")
    val subCategories: List<CategoryDto>? = null,
    @SerialName("created_at")
    override val createdAt: String = "",
    @SerialName("updated_at")
    override val updatedAt: String = "",
) : DateAble
